import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { type CvpRangeMachine } from "@packsize/schemas/machines";

import { getCvpRangeMachines } from "@/api/machines/cvp-range-api-v2";

import { type UseMachinesQueryOptions } from "../types";

import { CVP_RANGE_MACHINES_QUERY_KEY } from "./query-keys";

const REFETCH_INTERVAL = 15 * 1000;

export const getCvpRangeMachinesQuery = <TData = CvpRangeMachine[], TError = Error>(
	options?: UseMachinesQueryOptions<TData, TError>,
) => ({
	queryKey: CVP_RANGE_MACHINES_QUERY_KEY,
	queryFn: getCvpRangeMachines,
	refetchInterval: REFETCH_INTERVAL,
	staleTime: 10 * 1000,
	...options,
});

export const useCvpRangeMachines = (
	options?: UseMachinesQueryOptions<CvpRangeMachine[], Error>,
): UseQueryResult<CvpRangeMachine[], Error> => {
	return useQuery<CvpRangeMachine[], Error>(getCvpRangeMachinesQuery(options));
};
